import Colors from 'modules/Colors';
import { CSSProperties, SVGProps } from 'react';

/**
 * Props interface for the YandexPlatformIcon component
 */
interface YandexPlatformIconProps extends SVGProps<SVGSVGElement> {
    /** Optional class name for styling */
    className?: string;
    /** Optional inline styles */
    style?: CSSProperties;
    /** Color of the icon, defaults to purple */
    color?: string;
    /** Size of the icon, defaults to 52 */
    size?: number;
    /** Optional click handler */
    onClick?: () => void;
}

const YandexPlatformIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 52,
    onClick,
}: YandexPlatformIconProps) => (
    <svg
        className={className}
        style={style}
        width={size}
        height={size * (40 / 92)}
        onClick={onClick}
        viewBox="0 0 92 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_453_174)">
            <path
                d="M14.1728 28.7438V26.9487C14.1728 24.5125 13.8899 23.3073 12.9127 21.2043L8.1554 10.9207H11.4469L15.4843 19.7168C16.6672 22.2815 17.1815 23.6149 17.1815 26.5641V28.7439L14.1728 28.7438ZM16.1015 19.5372L19.8559 10.9205H23.0189L19.2129 19.5373L16.1015 19.5372Z"
                fill={color}
            />
            <path
                d="M77.0471 24.3842L74.4499 28.7438H71.3382L75.4014 22.0248L71.4926 15.8443H74.9385L77.4072 19.7424L79.6187 15.8443H82.6789L79.0273 22.1018L83.2446 28.7438H79.7988L77.0471 24.3842ZM63.2632 21.1272H67.532V20.8709C67.532 19.2551 67.069 17.9985 65.5518 17.9985C64.0861 17.9985 63.3403 19.0756 63.2632 21.1272ZM66.2204 29.0002C62.3117 29.0002 60.1001 26.8204 60.1001 22.3325C60.1001 18.4345 61.8745 15.5878 65.6032 15.5878C68.6635 15.5878 70.6434 17.2804 70.6434 21.7683V23.384H63.2632C63.3918 25.5382 64.2404 26.5896 66.4776 26.5896C67.9691 26.5896 69.5634 26.0254 70.5149 25.3843V27.8719C69.615 28.4873 68.1749 29.0003 66.2204 29.0003M49.9945 22.384C49.9945 25.3074 50.8176 26.5896 52.4889 26.5896C54.2119 26.5896 55.0863 25.2817 55.0863 22.2813C55.0863 19.3065 54.2634 17.9985 52.6174 17.9985C50.8688 17.9985 49.9945 19.3322 49.9945 22.384ZM46.8316 22.3839C46.8316 18.0755 48.8889 15.5878 51.846 15.5878C53.1833 15.5878 54.3148 16.2034 55.0863 17.3574V10.9204H58.1463V28.7442H55.3178L55.1634 27.0775C54.3404 28.334 53.1575 29.0007 51.7175 29.0007C48.8373 29.0007 46.8316 26.6414 46.8316 22.3843M37.5741 28.7442H34.5139V15.8453H37.4969L37.5741 16.9224H37.7283C38.3456 16.307 39.4255 15.6402 41.2513 15.6402C43.7457 15.6402 44.7742 16.7686 44.7742 19.333V28.7447H41.7143V19.6408C41.7143 18.6664 41.2256 18.2047 40.1455 18.2047C39.0397 18.2047 38.1398 18.7945 37.5741 19.487V28.7442ZM28.9594 22.7177H28.5223C25.8992 22.7177 24.845 23.2562 24.845 24.7692C24.845 25.9234 25.4878 26.6926 26.7736 26.6926C27.8535 26.6926 28.5736 26.2309 28.9593 25.6669L28.9594 22.7177ZM32.0194 25.5899C32.0194 26.6414 32.071 27.6929 32.1738 28.7442H29.1908C29.088 28.4877 28.9851 28.0519 28.9593 27.7185H28.8308C28.2393 28.334 27.4677 28.9238 25.6678 28.9238C23.302 28.9238 21.7077 27.462 21.7077 24.8463C21.7077 22.2303 23.7906 20.6917 28.4708 20.6917H28.9594V19.9736C28.9594 18.5887 28.2908 18.0759 26.8251 18.0759C25.2563 18.0759 23.4564 18.7427 22.6333 19.3582V16.8194C23.5592 16.2807 25.1535 15.6396 27.185 15.6396C30.4252 15.6396 32.0194 16.8193 32.0194 19.948V25.5899Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="clip0_453_174">
                <rect width="75.0893" height="18.08" fill="white" transform="translate(8.1554 10.92)" />
            </clipPath>
        </defs>
    </svg>
);

export default YandexPlatformIcon;
